import { Reveal, Eyebrow } from "@/components/Reveal";
import { Monogram } from "@/components/Monogram";

const About = () => (
    <section
        id="sobre"
        data-testid="about-section"
        className="relative py-24 sm:py-32 bg-[#0a0a0e] border-y border-line/60 overflow-hidden scroll-mt-16"
    >
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_45%_55%_at_50%_50%,rgba(212,175,55,0.05),transparent_70%)]" />

        <div className="relative mx-auto max-w-3xl px-5 sm:px-8 flex flex-col items-center gap-8 text-center">
            <Reveal>
                <Monogram className="w-12 h-12" />
            </Reveal>
            <Reveal delay={0.05}>
                <Eyebrow>Sobre a SETH</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-ink leading-[1.15]">
                    Digital, mas com <span className="text-gold-grad">visão de negócio.</span>
                </h2>
            </Reveal>
            <Reveal delay={0.18}>
                <p className="text-base sm:text-lg text-ink2 leading-relaxed">
                    A SETH nasceu para ajudar pequenos negócios a enxergarem o digital de uma forma
                    mais estratégica.
                </p>
            </Reveal>
            <Reveal delay={0.24}>
                <p className="text-base sm:text-lg text-ink2 leading-relaxed">
                    Porque estar presente não é suficiente. É preciso saber como sua empresa está
                    sendo percebida, encontrada e escolhida.
                </p>
            </Reveal>
            <Reveal delay={0.3} className="w-full flex flex-col items-center gap-5">
                <span className="rule-gold w-40" />
                <p className="font-mono2 text-[10px] sm:text-[11px] uppercase tracking-[0.3em] text-gold">
                    Estratégia + Tecnologia + Presença Digital + Resultado
                </p>
            </Reveal>
        </div>
    </section>
);

export default About;
